import React from 'react';

import { flagStyles } from '../settings';

const SvgBY = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-816px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBY;
